import { render, staticRenderFns } from "./CookiesNotice.vue?vue&type=template&id=4339a2bd"
import script from "./CookiesNotice.vue?vue&type=script&lang=js"
export * from "./CookiesNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports